import { Capacitor } from '@capacitor/core'
import { getIsDashboardsSupported } from 'App/dashboards/_utils/getIsDashboardsSupported'
import { useScreenSize } from 'utils/useScreenSize'

export const useIsDashboardsSupported = (): boolean => {
  const { screenWidth } = useScreenSize()

  return getIsDashboardsSupported({
    // Capacitor.getPlatform() is 'ios' / 'android' in the native apps, 'web' otherwise.
    isNativeApp: Capacitor.getPlatform() !== 'web',
    windowWidth: screenWidth,
    deviceScreenWidth: window.screen.width,
    deviceScreenHeight: window.screen.height,
  })
}
